module.exports = __webpack_public_path__ + "img/16-12.70e405f3.png";